<template>
    <div>
        <section>
            <div class="inner row5">
                <h1 class="boardTitle">카테고리 관리</h1>
                <div>
                    <div class="row4">
                        <div class="topContent flex">
                            <div class="left flex">
                                <p>총 <span>{{ productCount + serviceCount }}</span>건</p>
                                <div class="tops">
                                    <div class="tabMenu secItemMG">
                                        <button class="accountTabBtn" :class="{active: currentTab===0}" v-on:click="setTabChange(0, 'PRODUCT')">
                                            제품 <span> {{productCount}} </span>
                                        </button>
                                        <button class="accountTabBtn" :class="{active: currentTab===1}" v-on:click="setTabChange(1, 'SERVICE')">
                                            서비스 <span> {{serviceCount}} </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <input type="text" class="searchInput" v-model="searchText" @keyup.enter="searchCategory"/>
                                <input type="button" value="검 색" class="searchBtn searchBtnCmmn" @click="searchCategory"/>
                                <input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" @click="resetSearchText"/>
                                <div class="btnBox blankLeft inlineB">
                                    <button type="button" class="greenBtn smBtn" @click="goWrite()">등록</button>
                                    <button type="button" class="orangeBtn smBtn" @click="deleteBtn()">삭제</button>
                                </div>
                                <ModalCategory 
                                    v-if="isShowModalCategory" 
                                    v-bind:type=type
                                    v-bind:isModify=isModify 
                                    v-bind:mod_category=mod_category
                                    v-bind:mod_categoryIdx=mod_categoryIdx
                                    v-bind:mod_industryIdx=mod_industryIdx
                                    v-bind:mod_placeIdx=mod_placeIdx
                                    v-bind:mod_targetIdx=mod_targetIdx
                                    v-bind:mod_lifeIdx=mod_lifeIdx
                                    @modal-closed='handleModalClosed'/>
                            </div> 
                        </div>
                        <div class="joinTabContent">
                            <!-- tab 1 -->
                            <div>
                                <div class="tableContainer"> 
                                    <div class="sampleTemplate">
                                        <b-table
                                        id="table"
                                        :fields="fields"
                                        :items="getCategory"
                                        :per-page="perPage"
                                        :current-page="currentPage"
                                        @head-clicked="onHeadClicked"
                                        :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc"
                                        :select-mode="selectMode"
                                        ref="table"
                                        selectable
                                        @row-selected="onRowSelected"
                                        hover
                                        show-empty
                                        empty-text="카테고리가 존재하지 않습니다.">
                                            <template #cell(SELECTED)="{ rowSelected }">
                                                <template v-if="rowSelected">
                                                    <span aria-hidden="true">&check;</span>
                                                    <span class="sr-only">Selected</span>
                                                </template>
                                                <template v-else>
                                                    <span aria-hidden="true">&nbsp;</span>
                                                    <span class="sr-only">Not selected</span>
                                                </template>
                                            </template>
                                            <template #cell(NAME)="data">
                                                <span v-html="data.value" @click="showDetail(data.item)"></span>
                                            </template>
                                        </b-table>
                                        <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalCnt"
                                        :per-page="perPage"
                                        aria-controls="table">
                                        </b-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>   
</template>

<script>
import ModalCategory from '@/components/category/ModalCategory'
import {mapActions} from 'vuex'
import * as validationUtil from '@/utils/validationUtil'

export default {
    name: 'AccountManagement',
    components:{
        ModalCategory
    },
    data () {
        return {
            currentTab: 0,
            searchText:this.$route.query.searchText,
            productCount: 0,
            serviceCount: 0,
            perPage: 10,
            currentPage: 1,
            type : "PRODUCT",
            isModify: false,
            mod_category: '',
            mod_categoryIdx: 0,
            mod_industryIdx:0,
            mod_placeIdx: 0,
            mod_targetIdx: 0,
            mod_lifeIdx: 0,
            totalCnt: 0,
            selectMode: 'multi',
            selected: [],
            sortBy: 'REGDATE',
            sortDesc: false,
            fields: [
                {
                    // virtual column
                    key: 'SELECTED',
                    label: '선택',
                    class: 'text-center',
                },
                {
                    // virtual column
                    key: 'ROWNUM',
                    label: 'NO.',
                    class: 'text-center'
                },
                {
                    key: 'INDUSTRY',
                    label: '제품 산업 분류(1차)',
                    sortable: false,
                    class: 'text-center',
                },
                {
                    key: 'NAME',
                    label: '제품 종류(2차)',
                    sortable: false,
                    class: 'text-center',
                },
                {
                    key: 'REGDATE',
                    label: '등록일',
                    sortable: false,
                    class: 'text-center',
                }

            ],
            isShowModalCategory: false
        }
    },
    watch: {
        type: function (val) {
            if(val === 'PRODUCT'){
                this.fields['2'].label = "제품 산업 분류(1차)"
                this.fields['3'].label = "제품 종류(2차)"
            }

            if(val === 'SERVICE'){
                this.fields['2'].label = "서비스 산업 분류(1차)"
                this.fields['3'].label = "서비스 종류(2차)"
            }
        }
    },
    methods:{
        ...mapActions('category', [
            'requestCategoryList',
            'requestCategory',
            'deleteCategory'
        ]),
        onRowSelected(items) {
            this.selected = items
        },
        onHeadClicked(key) {
            if(key === 'SELECTED'){
                this.$refs.table.selectAllRows()
            }
        },
        goWrite() {
            this.isShowModalCategory = true
        },
        getCategory(){
            return this.requestCategoryList({
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                searchText : this.searchText,
                type : this.type
            })
            .then((response) => {
                const items = response.data.items;
                this.totalCnt = response.data.totalCnt;
                this.productCount = response.data.productCount;
                this.serviceCount = response.data.serviceCount;

                return items
            })
            .catch(() => {
                this.$alert('알림', '데이터를 가져올 수 없습니다.')
                return []
            })
        },
        resetSearchText(){
            this.searchText = "";
            let path = `/admin/categoryManagement`;
            if (this.$route.fullPath !== path){
                this.$router.push({ path:'/admin/categoryManagement' });
            }

            this.searchCategory()

        },
        searchCategory(){
            var path = "/admin/categoryManagement"
            if(!validationUtil.isEmpty(this.searchText)){
                path += `?searchText=${this.searchText}`
            }

            if (this.$route.fullPath !== path){
                if(!validationUtil.isEmpty(this.searchText)){
                    this.$router.push({ path:'/admin/categoryManagement', query: { searchText : this.searchText }});
                }
                else{
                    this.$router.push({ path:'/admin/categoryManagement'});
                }
            }

            this.$refs.table.refresh();
        },
        setTabChange(currentTab, type){
            this.currentTab = currentTab;
            this.type = type;

            this.$refs.table.refresh();
        },
        showDetail(row){
           return this.requestCategory(row.IDX)
            .then((response) => {
                const category = response.data

                this.isModify = true
                this.mod_category = category.NAME
                this.mod_categoryIdx = category.IDX
                this.mod_industryIdx = category.CATEGORY_INDUSTRY_IDX
                this.mod_placeIdx = category.CATEGORY_PLACE_IDX
                this.mod_targetIdx = category.CATEGORY_TARGET_IDX
                this.mod_lifeIdx = category.CATEGORY_LIFE_IDX

                this.isShowModalCategory = true
            })
            .catch(() => {
                this.$alert('알림', '데이터를 가져올 수 없습니다.')
            })
        },
        deleteBtn(){
            let selected = this.selected;
            if(selected.length == 0){
                this.$alert("알림", "삭제할 항목을 선택해주세요.");
                return false;
            }
            
            var response = this.$createConfirmResponse()
            this.$confirm("알림", `${selected.length}개의 항목을 삭제하시겠습니까?`, "확인", "취소", response, {
                'closed': () => {
                    if(response.result){
                        var categoryIdxList = []
						selected.forEach((item)=>{
							categoryIdxList.push(item.IDX)
						})

                        this.deleteCategory(categoryIdxList)
                        .then(response => {
							if(response.data === true){
								this.$alert('알림', '삭제가 완료되었습니다.', null, {
									'closed': () => {
										this.$refs.table.refresh()
									}
								})
							}
							else{
								this.$alert('알림', '카테고리 삭제에 실패했습니다.')
							}
						})
						.catch(() => {
                            this.$alert('알림', '데이터 통신을 실패했습니다.')
						})
                    }
                }
            });
        },
        handleModalClosed(value, param){
			if(value === ModalCategory.name){
				this.isShowModalCategory = false

				if(param.result == true){
					this.$refs.table.refresh()
				}

                if(this.isModify){
                    this.isModify = false
                    this.mod_category = ''
                    this.mod_categoryIdx = 0
                    this.mod_industryIdx = 0
                    this.mod_placeIdx = 0
                    this.mod_targetIdx = 0
                    this.mod_lifeIdx = 0
                }
			}
		}
    }
}

</script>

<style scoped>
    .countSpan {
        display: inline-block;
        padding: 5px 20px;
        font-size: 24px;
        line-height: 35px;
    }
    .grayBtn {
        background: #5D5D5D;
        border: 1px solid #BDBDBD;
        color: #FFF;
    }
    .grayBorderBtn {
        border: 1px solid #5D5D5D;
        color: #5D5D5D;
    }
    .left.flex {
        align-items: flex-end;
    }
    .secItemMG button:nth-of-type(2) {
        margin: 0 0 0 10px;
    }
</style>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
        @import "~bootstrap-vue/dist/bootstrap-vue.min";
    }
</style>